import { useContext, useEffect, useMemo } from 'react';
import { ChatContextType } from '@trinity/chat';
import { ActivePageContext, ChatContextItemsContext } from '@trinity/chat-components/components/Chat/context';
import type { ChatState } from './interfaces.chat';

export function useActivePageSync(chatInstance: ChatState.State['session']['chatInstance']): void {
  const { setPage } = useContext(ActivePageContext);
  const contextItems = useContext(ChatContextItemsContext);
  const activeContext = chatInstance.context;

  const matchedContext = useMemo(() => {
    if (activeContext.type !== ChatContextType.Agent) {
      return null;
    }

    return contextItems.find((item) => item.identifier === activeContext.data.identifier) ?? null;
  }, [activeContext, contextItems]);

  useEffect(() => {
    // Custom pages are only supported by Agent contexts.
    if (activeContext.type !== ChatContextType.Agent) {
      setPage(null);
      return;
    }

    setPage(matchedContext?.pageId ?? null, matchedContext?.layout);
  }, [activeContext.type, matchedContext?.layout, matchedContext?.pageId, setPage]);
}
